import { useMemo, useState } from 'react';
import type { ReactNode } from 'react';
import { ContextePerimetreSites, TOUS_LES_SITES } from './context';

/**
 * Périmètre de travail courant. Il est porté par l'application et non par
 * chaque écran : changer de site depuis la barre de sites filtre toutes les
 * listes, tableaux et exports (CDC §2.3).
 */
export function FournisseurPerimetre({ children }: { children: ReactNode }): JSX.Element {
  const [site, definirSite] = useState<string>(TOUS_LES_SITES);
  const valeur = useMemo(() => ({ site, definirSite }), [site]);
  return (
    <ContextePerimetreSites.Provider value={valeur}>
      {children}
    </ContextePerimetreSites.Provider>
  );
}
